import { ChevronRight } from '@mui/icons-material';
import {
  Box,
  Button,
  ButtonProps,
  ListItemButton,
  Menu,
  MenuProps,
} from '@mui/material';
import React, { useState } from 'react';

type SubMenuProps = Omit<MenuProps, 'anchorEl' | 'open' | 'onClose'> & {
  buttonProps?: ButtonProps;
  buttonChildren?: React.ReactNode;
  dense?: boolean;
  useRegularButton?: boolean;
};

export default function SubMenu(props: SubMenuProps) {
  const {
    dense,
    buttonProps,
    buttonChildren,
    children,
    useRegularButton,
    ...rest
  } = props;

  const [anchor, setAnchorEl] = useState<null | HTMLElement>(null);

  const ButtonComponent: React.FC<ButtonProps> = useRegularButton
    ? Button
    : (ListItemButton as typeof Button);

  return (
    <>
      <ButtonComponent
        {...buttonProps}
        {...{
          dense: dense,
        }}
        onClick={(e) => setAnchorEl(e.currentTarget)}
      >
        {buttonChildren}
        <Box ml={1} display="flex" alignItems="center">
          <ChevronRight color="primary" />
        </Box>
      </ButtonComponent>
      <Menu
        {...rest}
        anchorEl={anchor}
        open={Boolean(anchor)}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        {children}
      </Menu>
    </>
  );
}
